export default "__VITE_ASSET__tCYP_Sy9__"